import React from "react";
import {
  SFStack,
  SFDialog,
  SFTypography,
  SFUseStyled,
  SFToggleButtons,
  SFButton,
  SFIcons,
} from "@sf-core";
import { useNavigate } from "react-router-dom";
import { getCourseUrl } from "../../constants/urls";
import { saveCourseTrack } from "../../services/courseService";

const { styled } = SFUseStyled();

const StyledSFStack = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(1, 4, 3, 4),
}));

const GroupInfoDialog = ({
  groupDialog,
  onClose,
  skillPathId,
}) => {
  const navigate = useNavigate();

  return (
    <SFDialog
      size={"md"}
      contentZeroPadding
      titleBottomLine
      lightBackgroundDialog
      open={groupDialog.open}
      onClose={onClose}
      header={
        <SFStack direction="column" spacing={2.5}>
          <SFTypography variant="courseCarouselTitle" component="h2">
            {groupDialog.title}
          </SFTypography>
          <SFTypography variant="body2">{groupDialog.description}</SFTypography>
        </SFStack>
      }
      actionsBoxShadow
      actionBtns={
        <SFStack direction="row" alignItems="center" spacing={2}>
          <SFButton variant="transparent" onClick={onClose}>
            <SFTypography>{groupDialog.closeButton}</SFTypography>
          </SFButton>
          {groupDialog.secondaryButton && (
            <SFButton
              variant="secondary"
              onClick={() => {
                let data = {
                  skillPathId: skillPathId,
                  contentId: groupDialog.secondaryButton?.courseId,
                };
                saveCourseTrack(data);
                navigate(getCourseUrl(groupDialog.secondaryButton?.courseId));
              }}
              startIcon={<SFIcons.SFPlayIcon />}
            >
              <SFTypography>{groupDialog.secondaryButton?.label}</SFTypography>
            </SFButton>
          )}
        </SFStack>
      }
    >
      <>
        <StyledSFStack direction="column" spacing={2}>
          <SFTypography variant="body2bold">
            {groupDialog.label}
          </SFTypography>
          <SFToggleButtons
            size="small"
            disabled={true}
            spacing={1}
            variant={"dark"}
            items={groupDialog.skills?.map((x) => ({
              value: x.id,
              label: x.name,
            }))}
            noHover
            haveCollapsibleItems={true}
            limit={30}
          />
        </StyledSFStack>
      </>
    </SFDialog>
  );
};

export default GroupInfoDialog;
